module.exports = __webpack_public_path__ + "static/st-louis-3e779d87baa7ef58b8a8e6e8ad24267b.png";